export default __webpack_public_path__ + "static/media/Ballroll_00200.34672a57.png";